module.exports = __webpack_public_path__ + "img/Danee.42bc8b50.jpg";